import request from '../utils/request'

export default {
    saveEmail(formData: any) {
        return request.post("/homepage/saveEmail", formData)
    }
}